/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function getPrimaryProductInterestsQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;

    return new DataServiceQuery(
        'AvaGetPrimaryProductInterest',
        'AvaGetPrimaryProductInterestEntity',
        DataServiceEntities.AvaGetPrimaryProductInterestEntity,
        key
    );
}

export function createGetPrimaryProductInterestsInput(): IDataServiceRequest {
    const query = getPrimaryProductInterestsQuery();

    return query.createDataServiceRequestForOperation(
        'AvaGetPrimaryProductInterestDetails?$top=1000&count=true',
        false,
        DataServiceEntities.AvaGetPrimaryProductInterestEntity,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.AvaGetPrimaryProductInterestEntity' }
    );
}

export function getPrimaryProductInterestsAsync(context: IContext): AsyncResult<DataServiceEntities.AvaGetPrimaryProductInterestEntity[]> {
    const request = createGetPrimaryProductInterestsInput();
    return callActionOrExecute<DataServiceEntities.AvaGetPrimaryProductInterestEntity[]>(request, context.callerContext);
}
